<template>
  <div class="survey">
    <md-content class="md-elevation-4 md-alignment-center-center card-meoempresas">
      <div class="middle-card">
        <img alt="Meo Empresas" src="@/assets/images/logo-meoempresas-horizon.png" class="icon-meoempresas md-size-5x">
      </div>
      <span class="md-title">Portal de Inquéritos Clientes B2B</span>
    </md-content>
  </div>
</template>

<script>
export default {
  name: 'Index'
}
</script>

<style lang="scss">
.survey {
  margin: 10px;
}
.card-meoempresas {
  margin: auto auto;
  max-width: 1000px;
  min-height: 45vh;
}
.middle-card {
  margin-top: 30px;
  padding-top: 10vh;
}
.icon-meoempresas{
  margin: auto auto;
  margin-bottom: 40px;
}
</style>
